<ui-icon
    name="info"
    advizeoTooltipImportance="high"
    size="small"
    [advizeoTooltip]="text | striphtml | truncate: textLengthLimit : true"
    [class.cursor-hand]="canOpenModal()"
    (click)="displayHelp()"
/>
